import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlSearchIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.53 22.47L19.1 18.04C20.74 16.15 21.75 13.69 21.75 11C21.75 5.07 16.93 0.25 11 0.25C5.07 0.25 0.25 5.07 0.25 11C0.25 16.93 5.07 21.75 11 21.75C13.69 21.75 16.15 20.75 18.04 19.1L22.47 23.53C22.76 23.82 23.24 23.82 23.53 23.53C23.82 23.24 23.82 22.76 23.53 22.47ZM11 20.25C5.9 20.25 1.75 16.1 1.75 11C1.75 5.9 5.9 1.75 11 1.75C16.1 1.75 20.25 5.9 20.25 11C20.25 16.1 16.1 20.25 11 20.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlSearchIcon.displayName = 'CtrlSearchIcon';
